export default __webpack_public_path__ + "static/media/lifesatisfaction5Img4.78d89fa2.png";